export const ENVIRONMENT = "CITIZEN"

export const ENVIRONMENT_SMS_RETRIEVER_HASH = {
    "CITIZEN": "G74gAFud3Ap",
    "JAMMU": "/4kUicVNKKa",
    "NOIDA": "G74gAFud3Ap"
};